// Authors: Ben Croker
// Icon: material-symbols:timer-play-outline
// Slug: Runs an expression when the element is loaded
// Description: This attribute runs an expression when the element is loaded.

import {
  type AttributePlugin,
  PluginType,
  Requirement,
} from '../../../engine/types'
import { tagToMs } from '../../../utils/tags'
import { modifyViewTransition } from '../../../utils/view-transtions'
import { delay } from '../../../utils/timing'

const once = new WeakSet<HTMLOrSVGElement>()

export const OnLoad: AttributePlugin = {
  type: PluginType.Attribute,
  name: 'onLoad',
  keyReq: Requirement.Denied,
  valReq: Requirement.Must,
  onLoad: ({ el, mods, genRX, evalRX }) => {
    const { dm, deps, rxFn } = genRX()
    let callback = () => evalRX(rxFn, dm, deps)
    callback = modifyViewTransition(callback, mods)

    let wait = 0
    const delayArgs = mods.get('delay')
    if (delayArgs) {
      wait = tagToMs(delayArgs)
    }

    // Delay the callback regardless of whether the modifier is set so that other plugins are processed first.
    callback = delay(callback, wait)

    if (!once.has(el)) {
      callback()
    }

    if (mods.has('once')) {
      once.add(el)
    }

    return () => {
      if (!mods.has('once')) {
        once.delete(el)
      }
    }
  },
}
